import axios from './axios_config';

export const getOptionsUserBillingDetails = async () => {
    let result = await axios.options('/api/v1/subscription/billing-details/');
    return result;
};

export const getUserBillingDetails = async () => {
    let result = await axios.get('/api/v1/subscription/billing-details/');
    return result;
};

export const saveUserBillingDetails = async (data) => {
    let result = await axios.post(
        '/api/v1/subscription/billing-details/',
        data
    );
    return result;
};

export const changePassword = async (id, data) => {
    let result = await axios.patch(
        `/api/v1/users/change-password/${id}/`,
        data
    );
    return result;
};

export const changeUserData = async (id, data) => {
    let result = await axios.patch(`/api/v1/users/user/${id}/`, data)
    return result;
};

export const sendErrorsToServer = async (data) => {
    let result = await axios.post(`/logger`, {email_content: data})
    // .then(res=>{console.log( `success`)
    // .catch(err=>{console.log(`error`)})});
    return result;
};
